export type MobileLockModalData = {
  buildDeepLinkUrl: () => string;
  studentName: string;
  translationKeys: MobileLockTranslationKeys;
  openApp: () => void;
};

export type MobileLockTranslationKeys = {
  TITLE: string;
  SUBTITLE: string;
  CTA: string;
};

export enum MobileLockType {
  LOGGED_IN = 'loggedIn',
  LOGGED_OUT = 'loggedOut',
}

export type MobileLockConfig = {
  allowMobileParam: string;
  excludedRoutes: string[];
  isBranchEnabled: boolean;
};

export type MobileLockTranslationKeysMap = Record<
  MobileLockType,
  {
    TITLE: string;
    SUBTITLE: string;
    CTA: string;
  }
>;



// WEBPACK FOOTER //
// ./ts/app/shared/mobile-lock/mobile-lock.types.ts